import React from "react";
import { Field } from "react-final-form";
import { TextField, MenuItem } from "@mui/material";
import RffInputWrapper from "../shared/RffInputWrapper";
import normalizeOptions from "../../../utils/finalForm/normalizeOptions";

const RffSelectField = ({
  name,
  label,
  options: rawOptions = [],
  required = false,
  helperText,
  fullWidth = true,
  row = false,
  suppressGrid,
  size,
  disabled,
  placeholder,
}) => {
  // Option lists shared with the LOS arrive as plain strings; the ones defined
  // here are { value, label }. Accept both.
  const options = normalizeOptions(rawOptions);

  return (
  <RffInputWrapper
    label={label}
    suppressGrid={suppressGrid}
    size={size}
    helperText={helperText}
    required={required}
    row={row}
  >
    <Field
      name={name}
      validate={(v) =>
        required && (v == null || v === "") ? "This field is required" : undefined
      }
      parse={(v) => (v === "" ? undefined : v)}
      render={({ input, meta }) => (
        <TextField
          select
          {...input}
          disabled={disabled}
          fullWidth={fullWidth}
          placeholder={placeholder}
          error={meta.touched && !!meta.error}
          helperText={meta.touched && meta.error ? meta.error : null}
          SelectProps={{ displayEmpty: !!placeholder }}
        >
          {placeholder && (
            <MenuItem value="" disabled>
              {placeholder}
            </MenuItem>
          )}
          {options.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  </RffInputWrapper>
  );
};

export default RffSelectField;
